<template>
    <section>
        <ul :class="$style.shop_cards">
            <li
                v-for="card in SHOP_CARDS"
                :key="card.id"
                :class="[$style.shop_cards__item, $style[card.id]]"
            >
                <img
                    :src="card.src"
                    :alt="card.title"
                />
            </li>
        </ul>
        <img
            :class="$style.pic_stay_tuned"
            :alt="$tr('rewards.alt_stay_tuned')"
            :src="StayTunedImg"
        />
    </section>
</template>

<script setup lang="ts">
import StayTunedImg from '@/components_new/ShopCards/images/stay_tuned.svg'
import SteamLogo from '@/components_new/ShopCards/images/steam.svg'
import NintendoLogo from '@/components_new/ShopCards/images/nintendo.svg'
import PlaystationLogo from '@/components_new/ShopCards/images/playstation.svg'
import XboxLogo from '@/components_new/ShopCards/images/xbox.svg'
import BlizzardLogo from '@/components_new/ShopCards/images/blizzard.svg'
import LegendsLogo from '@/components_new/ShopCards/images/legends.svg'
import PubgLogo from '@/components_new/ShopCards/images/pubg.svg'
import EALogo from '@/components_new/ShopCards/images/ea.svg'

const SHOP_CARDS = [
    {
        title: 'Steam',
        id: 'steam',
        src: SteamLogo,
    },
    {
        title: 'Nintendo',
        id: 'nintendo',
        src: NintendoLogo,
    },
    {
        title: 'Play Station',
        id: 'playstation',
        src: PlaystationLogo,
    },
    {
        title: 'Xbox',
        id: 'xbox',
        src: XboxLogo,
    },
    {
        title: 'Blizzard',
        id: 'blizzard',
        src: BlizzardLogo,
    },
    {
        title: 'EA games',
        id: 'ea',
        src: EALogo,
    },
    {
        title: 'League of Legends',
        id: 'league',
        src: LegendsLogo,
    },
    {
        title: 'PUBG mobile',
        id: 'pubg',
        src: PubgLogo,
    },
]
</script>

<style module>
.shop_cards {
    position: relative;
}

.shop_cards:after {
    content: '';
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.51) 36.86%, #000 100%);
    position: absolute;
    top: 0;
    bottom: 0;
    /* cover slightly more are on the sides to fix rendering issues over contrast(white) cards */
    left: -1px;
    right: -1px;
}

.shop_cards__item {
    position: relative;
    border-radius: 12px;
    display: flex;
    aspect-ratio: var(--thumbnail-aspect-ratio);
}
.shop_cards__item img {
    display: block;
    height: auto;
    object-fit: contain;
}

.shop_cards__item.steam {
    background-color: #29292e;
}
.shop_cards__item.nintendo {
    background-color: #e60012;
}
.shop_cards__item.playstation {
    background: linear-gradient(180deg, #0262ac 0%, #054394 100%);
}
.shop_cards__item.xbox {
    background-color: #107c0f;
}
.shop_cards__item.blizzard {
    background-color: #000000;
}
.shop_cards__item.league {
    background-color: #110e1f;
}
.shop_cards__item.pubg {
    background-color: rgba(255, 255, 255, 0.8);
}
.shop_cards__item.ea {
    background-color: #285ca7;
}

.pic_stay_tuned {
    width: 265px;
    height: 120px;
    display: block;
    align-self: center;
    margin: 32px auto 32px;
}

@media (--mobile) {
    .shop_cards li {
        aspect-ratio: auto;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        height: 100px;
        margin-bottom: -30px;
    }

    .shop_cards__item img {
        box-sizing: border-box;
        height: 70px;
        padding: 16px;
    }
}

@media (--mobile-landscape), (--tablet-plus) {
    .shop_cards {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
    }

    .shop_cards__item {
        justify-content: center;
    }

    .shop_cards__item img {
        width: 50%;
    }
    .shop_cards__item.playstation img {
        width: 80%;
    }
    .shop_cards__item.xbox img {
        width: 30%;
    }
}
</style>
